export default {
    smartSearch: {
        syntaxHelper: '搜索幫助 >',
        sections: {
            ANCS: '[標]當前申請(專利權)人',
            AUTOCOMPLETE: '自動推薦',
            FIELD: '字段',
            HISTORY: '歷史記錄',
            KEYWORDS: '關鍵詞',
            LOGIC: '邏輯詞',
            keywordFields: '關鍵詞字段',
            assigneeFields: '申請人字段',
            classificationNumberFields: '分類號字段',
            otherFields: '其它字段',
            SAMPLE: '樣例',
            CASE_NATURE: '案件性質',
            TRIAL_GRADE: '訴訟審級',
            PLE_TYPE: '質押類型',
            PATENT_TYPE: '專利類型',
            AUTHORITY: '受理局',
            ANS_TYPE: '[標]原始申請(專利權)人類型',
            CASE_REGION: '案件地區',
            EXCLUSIVITY: '許可排他性',
            SIMPLE_LEGAL_STATUS: '簡單法律狀態',
            LEGAL_STATUS: '法律狀態',
            LEGAL_EVENT: '法律事件',
            CITE_CATEGORY: '引用類別',
            OUTCOME_STATUS: '案件狀態',
            ANCS_TYPE: '[標]當前申請(專利權)人類型',
            GOV: '政府利益',
            LICENSE: '專利許可',
            LITIGATION: '專利訴訟',
            PLEDGE: 'PLEDGE',
            REEXAMINVALID: 'REEXAMINVALID',
            SEP_SOURCE: 'SEP數據源',
            GNAME: '自定義申請人組',
            EPDS_LS: 'EP指定國家/地區法律狀態',
            EPDS_SLS: 'EP指定國家/地區簡單法律狀態',
            ATC_VALUE: '委托代理機構專利',
            UP_STATUS: '歐洲統一法院狀態',
            EFAM_STATUS: 'PatSnap同族狀態',
        },
        keywordQueryTitle: '在當前光標位置後追加{keyword}的擴展詞',
    },
};
